export const MfaType = {
    TOTP: "totp",
    SMS: "sms",
    EMAIL: "email",
    SKIP: "skip"
}